import { render, staticRenderFns } from "./hokl_hosm_mail_components.vue?vue&type=template&id=39e9bfcb&scoped=true"
import script from "./hokl_hosm_mail_components.vue?vue&type=script&lang=js"
export * from "./hokl_hosm_mail_components.vue?vue&type=script&lang=js"
import style0 from "./hokl_hosm_mail_components.vue?vue&type=style&index=0&id=39e9bfcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e9bfcb",
  null
  
)

export default component.exports